module.exports = __webpack_public_path__ + "img/Graph_Grey_Icon.6bb5269e.png";